var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "asc__showPage" }, [
    _c("div", { staticClass: "asc__showPage-times" }, [
      _c("i", {
        staticClass: "fas fa-times-circle",
        on: {
          click: function($event) {
            return _vm.closeQuick()
          }
        }
      })
    ]),
    _vm._v(" "),
    _vm.rowData
      ? _c(
          "div",
          { staticClass: "asc__showPage-container" },
          [
            _c(
              "b-row",
              [
                _c("b-col", { attrs: { cols: "12" } }, [
                  _c(
                    "header",
                    [
                      _c("Breadcrumb", {
                        attrs: { title: _vm.rowData.Description1 }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "clearfix" })
                    ],
                    1
                  )
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-tabs",
              [
                _c(
                  "b-tab",
                  {
                    attrs: {
                      title: _vm.$t("get.AccountTransaction.AT"),
                      active: ""
                    }
                  },
                  [
                    _c(
                      "b-row",
                      { staticClass: "p-4" },
                      [
                        _c(
                          "b-card",
                          { staticClass: "col-md-6 col-12 asc__showPage-card" },
                          [
                            _c("span", [
                              _c("i", { staticClass: "far fa-circle" }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("get.AccountTransaction.CustomerId")
                                  )
                              )
                            ]),
                            _c("p", [
                              _vm._v(
                                _vm._s(
                                  _vm.rowData.CustomerId &&
                                    _vm.rowData.Customer.Label
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _c("i", { staticClass: "far fa-circle" }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "get.AccountTransaction.DocumentNumber"
                                    )
                                  )
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(_vm._s(_vm.rowData.DocumentNumber))
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _c("i", { staticClass: "far fa-circle" }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "get.AccountTransaction.DocumentDate"
                                    )
                                  )
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", [_vm._v(_vm._s(_vm.rowData.DocumentDate))]),
                            _vm._v(" "),
                            _c("span", [
                              _c("i", { staticClass: "far fa-circle" }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "get.AccountTransaction.TransactionTypeId"
                                    )
                                  )
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                _vm._s(
                                  _vm.rowData.TransactionTypeId &&
                                    _vm.rowData.TransactionType.Label
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _c("i", { staticClass: "far fa-circle" }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "get.AccountTransaction.AccountTransaction"
                                    )
                                  )
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(_vm._s(_vm.rowData.AccountTransaction))
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-card",
                          { staticClass: "col-md-6 col-12 asc__showPage-card" },
                          [
                            _c("span", [
                              _c("i", { staticClass: "far fa-circle" }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("get.AccountTransaction.CurrencyId")
                                  )
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                _vm._s(
                                  _vm.rowData.CurrencyId &&
                                    _vm.rowData.Currency.Label
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _c("i", { staticClass: "far fa-circle" }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("get.AccountTransaction.Credit")
                                  )
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", [_vm._v(_vm._s(_vm.rowData.Credit))]),
                            _vm._v(" "),
                            _c("span", [
                              _c("i", { staticClass: "far fa-circle" }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("get.AccountTransaction.Remainder")
                                  )
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", [_vm._v(_vm._s(_vm.rowData.Remainder))]),
                            _vm._v(" "),
                            _c("span", [
                              _c("i", { staticClass: "far fa-circle" }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "get.AccountTransaction.CreditAccountRemainder"
                                    )
                                  )
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(_vm._s(_vm.CreditAccountRemainder))
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _c("i", { staticClass: "far fa-circle" }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("get.AccountTransaction.Genexp1")
                                  )
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", [_vm._v(_vm._s(_vm.rowData.Genexp1))])
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2557f348", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2557f348","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/AccountTransaction/get.vue
// module id = null
// module chunks = 